import { useRef, useEffect } from 'react';

const isDevelopmentRun = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export const useLegacyEffect = (callback: any, deps: any) => {
    const isMountedRef = useRef(!isDevelopmentRun);

    useEffect(() => {
        if (!isMountedRef.current) {
            isMountedRef.current = true;
            return undefined;
        }

        return callback();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
